import { InjectionToken } from '@angular/core';

export const SYNERISE_KEY = new InjectionToken<string>('SYNERISE_KEY');
